module.exports = __webpack_public_path__ + "img/Categories_bg_12.0e50b098.jpg";